'use strict';

import BaseService from './base.service';

class CashboxTransfersService extends BaseService {
  /* @ngInject */
  constructor(CashboxTransfer, SegaUser) {
    super(CashboxTransfer, SegaUser);
  }

  create(
    opts = {
      amount: 0,
      srcId: 0,
      dstId: 0,
      comments: '',
      collectable: true
    }
  ) {
    return this.Model.createNew({
      opts: opts
    }).$promise;
  }

  void(
    opts = {
      id: 0,
      reason: ''
    }
  ) {
    return this.Model.void({
      id: opts.id,
      reason: opts.reason
    }).$promise;
  }

  find() {
    return this.customFind.apply(arguments);
  }

  customFind(opts) {
    return this.getQueryOpts(opts).then(
      queryOpts =>
        this.Model.customFind({
          filter: queryOpts
        }).$promise
    );
  }
}

export default CashboxTransfersService;
